
import Range from 'vux/src/components/range/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'



function realFormatSecond (second) {
var secondType = typeof second
if (secondType === 'number' || secondType === 'string') {
second = parseInt(second)
var hours = Math.floor(second / 3600)
second = second - hours * 3600
var mimute = Math.floor(second / 60)
second = second - mimute * 60

return ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2)
} else {
return '00:00'
}
}
export default {
name: 'MusicPlayer',
props: {
title: {
type: String,
default: ''
},
content: {
type: String,
default: ''
},
authorName: {
type: String,
default: ''
},
bgImg: {
type: String,
default: '../../assets/logo.png'
},
recordImg: {
type: String,
default: ''
},
src: {
type: String,
default: "https://music.163.com/song/media/outer/url?id=668479.mp3"
},

rangeFlag: {
type: Boolean,
default: false
}
},
watch: {
sliderTime: {
handler (n, o) {

}
}
},

mounted () {
let that = this


this.$refs['player-btn'].addEventListener('click', function (e) {
that.startPlayOrPause(e)
}, false)
},

data () {
return {
audio: {
loadEnd: false,
playing: false,
currentTime: 0,
maxTime: 0,
},
sliderTime: 0,
isRotate: false,
}
},
computed: {
currentTime () {
return realFormatSecond(this.audio.currentTime)
},
maxTime () {
return realFormatSecond(this.audio.maxTime)
}
},


methods: {
clickNext () {
this.$emit('next')
},
clickPrev () {
this.$emit('prev')
},
onError () {
this.$emit('error')
},
onEnded () {
this.$emit('ended')
this.pause()
},
startPlayOrPause () {
return this.audio.playing ? this.pause() : this.play()
},
onPause () {
this.audio.playing = false
},
onPlay () {
this.audio.playing = true
},
onTouchStart (e) {
this.pause()
},
onTouchEnd (e) {
this.$refs.audio.currentTime = this.audio.currentTime
this.play()
},
onChange () {
if (!this.audio.playing) {
this.audio.currentTime = this.sliderTime / 100 * this.audio.maxTime
}
},
play () {
this.isRotate = true
this.$refs.audio.play()
this.$store.commit('play')
},
pause () {
this.isRotate = false
let matrix = getComputedStyle(this.$refs['rotate-wrapper'])['transform']  
let lastMatrix = this.$refs['rotate-content'].style.transform             
this.$refs['rotate-content'].style.transform = lastMatrix + matrix;       

this.$refs.audio.pause()
this.$store.commit('pause')
},
changeCurrentTime (index) {
},

onTimeupdate (res) {
this.audio.currentTime = res.target.currentTime
this.sliderTime = parseInt(this.audio.currentTime / this.audio.maxTime * 100)

},


onLoadedmetadata (res) {
this.audio.maxTime = parseInt(res.target.duration)
this.audio.loadEnd = true
this.$emit('load-success')


this.play()


},
},

components: {
Range,
XButton
}
}



// WEBPACK FOOTER //
// ./src/components/music_player/MusicPlayer.vue